export enum IDTypeEnum {
  uinfin = 'UIN',
  foreign_id = 'FIN',
  passport = 'PPN',
  special_pass = 'SPN',
  malaysian_id = 'MIC',
  foreign_birth_cert = 'FBC',
  other_id = 'XIN'
}
